const general = {
  "card.number": {
    format: {
      pattern: /^\d{14,16}$/,
      message: "Número do cartão com formato inválido."
    }
  },
  "card.cvv": {
    format: {
      pattern: /^\d{3,4}$/,
      message: "Código verificador inválido."
    }
  },
  "card.expiration": {
    format: {
      pattern: /^(1[0-2]|0[1-9])(1[8,9]|[2-9]\d{1})$/,
      message: "Digite uma data válida."
    }
  },
  "card.holderName": {
    presence: {
      allowEmpty: false,
      message: "Nome do dono do cartão é obrigatório."
    },
    length: {
      minimum: 2,
      maximum: 26,
      message: "Nome do cartão deve ser de 2 a 26 caracteres."
    }
  },
  "general.email": {
    presence: {
      allowEmpty: false,
      message: "E-mail é obrigatório"
    },
    email: {
      message: "E-mail com formato inválido"
    }
  }
};

const slip = {
  "general.emailSlip": {
    presence: {
      allowEmpty: false,
      message: "E-mail é obrigatório"
    },
    email: {
      message: "E-mail com formato inválido"
    }
  }
};

export default {
  general,
  slip
};



// WEBPACK FOOTER //
// ./src/core/constraint/payment.constraint.js